exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".progress-linear[data-v-531e46c8]{margin:0}.payed-at[data-v-531e46c8]{width:10em;margin-right:1em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Purchase.vue"],"names":[],"mappings":"AACA,kCAAoC,QAAU,CAC7C,AACD,2BACE,WAAY,AACZ,gBAAkB,CACnB","file":"Purchase.vue","sourcesContent":["\n.progress-linear[data-v-531e46c8] { margin: 0;\n}\n.payed-at[data-v-531e46c8] {\n  width: 10em;\n  margin-right: 1em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-531e46c8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Purchase.vue
// module id = 944
// module chunks = 6